import { Component, OnInit } from '@angular/core';
import { IEmployee } from '../employee';
import { ActivatedRoute, Route } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { IWorkTime } from '../models/work-time';
import { TimeSpan } from 'src/app/shared/helpers/time-span';
import { EmployeeStore } from 'src/app/stores/component/employee.store';
import { combineLatest, map } from 'rxjs';
import { WorkTimesStore } from 'src/app/stores/component/work-times.store';

@Component({
    selector: 'app-employee',
    templateUrl: './employee.component.html',
    styleUrls: ['./employee.component.css'],
    providers: [EmployeeStore, WorkTimesStore],
    standalone: false
})
export class EmployeeComponent implements OnInit {

  constructor(
    private activatedRoute : ActivatedRoute,
    private employeeStore: EmployeeStore,
    private workTimesStore: WorkTimesStore
  ) { }

  vm$ = combineLatest([
    this.employeeStore.employee$,
  ]).pipe(
    map(([
      employee,
    ]) => ({
      employee,
    }))
  );

  ngOnInit(): void {
    this.employeeStore.setEmployee(this.activatedRoute.snapshot.data['employee'] as IEmployee);

    this.workTimesStore.setWorkTimes(this.activatedRoute.snapshot.data['workTimes'] as IWorkTime[]);
  }
}
